// ONE published post, on a page whose route names it.
//
// `slug` is what to show and defaults to the parameter a `/blog/:slug` route
// supplies — the same `{{params.x}}` gen-2's element carried
// (archive/recovered/stack-pkg/src/schema/page-element/types/blog-post.js),
// except that here the route actually matches. A literal slug is allowed too:
// a page that pins one post.
//
// No template here. The post renders through the SITE's post template —
// `site.blog.templates.post`, edited on the blog's Templates tab, the built-in
// until somebody writes one (see @common/render/blog). It used to be a
// `sectionId` on this config; @common/schema/site/blog says why it moved.
export const schema = [
  {
    id: "/Page/Element/Type/BlogPost",
    type: "object",
    properties: {
      slug: {
        label: "Slug",
        type: "string",
        default: "{{params.slug}}",
      },
    },
    required: [],
  },
];
